import React, { useEffect, useState } from "react";
import { OutTable, ExcelRenderer } from "react-excel-renderer";
import { FiMaximize, FiArrowRight, FiArrowLeft } from "react-icons/fi";
import "./xlsx.css";
import { ControlButtons } from "../controlButtons";

export const XlsxViewer = ({ url, handleExpand, modal }) => {
  const [cols, setCols] = useState([]);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const limit = modal ? 15 : 5;

  useEffect(() => {
    let isMounted = true;

    const fetchXlsxData = async (url) => {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        let fileObj = new File([blob], "file.xlsx", {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        ExcelRenderer(fileObj, (err, resp) => {
          if (err) {
            console.error(err);
          } else {
            if (isMounted) {
              let pages = [];
              for (let i = 0; i < resp.rows.length; i += limit) {
                pages.push(resp.rows.slice(i, i + limit));
              }

              setCols(resp.cols);
              setRows(pages);
            }
          }
        });
      } catch (error) {
        console.error("Error fetching or parsing XLSX file:", error);
      }
    };

    fetchXlsxData(url);

    return () => {
      isMounted = false;
    };
  }, [url]);

  return (
    <div className="table-cont">
      {rows && (
        <OutTable
          data={rows?.[page] || []}
          columns={cols}
          tableClassName="ExcelTable2007"
          tableHeaderRowClass="heading"
        />
      )}
      {rows.length > 1 && (
        // <div
        //   className="d-flex justify-content-between"
        //   style={{
        //     border: "none",
        //     width: "660px",
        //     position: "sticky",
        //     left: "0",
        //   }}
        // >
        //   <div style={{ border: "none" }} className="pt-4 pl-0 bg-white">
        //     <button
        //       onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
        //       disabled={page === 0}
        //     >
        //       <FiArrowLeft className="" />
        //     </button>
        //     <span className="">
        //       {page + 1}/{rows.length}
        //     </span>
        //     <button
        //       onClick={() =>
        //         setPage((prev) => Math.min(prev + 1, rows.length - 1))
        //       }
        //       disabled={page === rows.length - 1}
        //     >
        //       <FiArrowRight className="" />
        //     </button>
        //   </div>
        //   {!modal && (
        //     <div style={{ border: "none" }} className="pt-4 pl-0 bg-white">
        //       <FiMaximize
        //         onClick={handleExpand}
        //         style={{ cursor: "pointer" }}
        //       />
        //     </div>
        //   )}
        // </div>
        <ControlButtons
          page={page}
          data={rows}
          handleExpand={handleExpand}
          setPage={setPage}
          modal={modal}
        />
      )}
    </div>
  );
};
